// These functions log to DataDog.
// These functions should all be "fire and forget".
// We don't want the web app to crash if metrics logging fails.
export var increment = function (_a) {
    var name = _a.name, tags = _a.tags;
    return fetch(process.env.CLEARDATA_API_HOST + "/metrics/v1/monitoring", {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
            events: [
                {
                    name: name,
                    type: 'increment',
                    tags: tags,
                },
            ],
        }),
    });
};
